/**
 * Transport class intended to be extended by concrete Transport implementations.
 * Transport and all child classes implement the EventListener interface by having handleEvent() method.
 *
 * @class
 * @method handleEvent
 * @static defaultOpts
 * @static initialize
 */
class Transport {
  constructor(opts) {
    // walk up ancestry aggregating defaultOpts
    let ancestorClass = Object.getPrototypeOf(this.constructor);
    let ancestorOpts = {};
    while (ancestorClass.defaultOpts) {
      ancestorOpts = Object.assign({}, ancestorClass.defaultOpts, ancestorOpts);
      ancestorClass = Object.getPrototypeOf(ancestorClass);
    }

    const _opts = Object.freeze( Object.assign(ancestorOpts, this.constructor.defaultOpts, opts) );
    Object.defineProperty(this, '_opts', {
      value: _opts
    });
  }

  /* c8 ignore next 3 */
  handleEvent() {
    throw new Error('handleEvent() must be implemented in inheriting classes');
  }

  static initialize(opts = {}) {
    return new this(opts);
  }
}

Transport.defaultOpts = Object.freeze({});

export {
  Transport as default,
  Transport
};
